/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const invoiceItems = sqliteTable('invoice_items', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  invoice_id: text('invoice_id'),
  service_name: text('service_name'),
  service_id: text('service_id'),
  qty: integer('qty'),
  unit_price: real('unit_price'),
  discount: real('discount'),
  discount_type: text('discount_type'),
  tax_rate: real('tax_rate'),
  inventory_item_id: text('inventory_item_id'),
  free_text_name: text('free_text_name'),
  description_snapshot: text('description_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  unit_price_snapshot: real('unit_price_snapshot'),
  tax_inclusive_snapshot: integer('tax_inclusive_snapshot'),
  open_pricing_snapshot: integer('open_pricing_snapshot'),
  source_type: text('source_type'),
  source_id: text('source_id'),
  remarks: text('remarks'),
  add_to_treatment: integer('add_to_treatment'),
  payment_status: text('payment_status'),
  sort_order: integer('sort_order'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
